import type React from 'react'
import { cn } from '../../../../shared/cn'

export function H2({ className, ...props }: React.ComponentPropsWithoutRef<'h2'>) {
  return <h2 {...props} className={cn('font-bold text-2xl lg:font-bold lg:text-3xl', className)} />
}
